export default __webpack_public_path__ + "static/media/Bracers of the Clay.78f93a63.jpg";